import { Mimbox } from "../types.js";
function dateIsTimestamp(date) {
    try {
        if (date && "toDate" in date) {
            return true;
        }
        return false;
    }
    catch (err) {
        return false;
    }
}
export function _createQrCodesConverter(Timestamp) {
    return {
        toFirestore(qrCode) {
            const converted = {};
            if (qrCode.created) {
                converted.created = Timestamp.fromDate(qrCode.created);
            }
            if (qrCode.on_plate) {
                converted.on_plate = Timestamp.fromDate(qrCode.on_plate);
            }
            return { ...qrCode, ...converted };
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            return {
                ...data,
                created: data.created.toDate(),
                on_plate: data.on_plate ? data.on_plate.toDate() : null,
            };
        },
    };
}
export function _createPasscodeConverter(Timestamp) {
    return {
        toFirestore(passcodeMetadata) {
            return {
                ...passcodeMetadata,
                expiresAt: passcodeMetadata.expiresAt
                    ? Timestamp.fromDate(passcodeMetadata.expiresAt)
                    : null,
            };
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            const { hashedPasscode, ...rest } = data;
            return {
                ...rest,
                expiresAt: data.expiresAt ? data.expiresAt.toDate() : null,
                id: snapshot.id,
            };
        },
    };
}
export function _createOrganizationConverter(Timestamp) {
    return {
        toFirestore(organization) {
            return {
                ...organization,
                created: Timestamp.fromDate(organization.created),
            };
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            return {
                ...data,
                created: data.created.toDate(),
            };
        },
    };
}
export function _createOrganizationsAndCustomersConverter() {
    return {
        toFirestore(entity) {
            // no defaults here: merge writes (partial updates) pass through this converter
            // and a default would overwrite the stored value
            return { ...entity };
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            return { ...data, id: snapshot.id };
        },
    };
}
export function _createPublicConfigConverter() {
    return {
        toFirestore(config) {
            const { id, ...data } = config;
            return data;
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            return { id: snapshot.id, ...data };
        },
    };
}
export function _createPrivateConfigConverter() {
    return {
        toFirestore(config) {
            const { id, ...data } = config;
            return data;
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            return { id: snapshot.id, ...data };
        },
    };
}
export function _createUserConverter(Timestamp) {
    return {
        toFirestore(modelObject) {
            const data = { ...modelObject };
            if (data.created_at instanceof Date) {
                data.created_at = Timestamp.fromDate(data.created_at);
            }
            if (data.last_seen instanceof Date) {
                data.last_seen = Timestamp.fromDate(data.last_seen);
            }
            return data;
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            let created_at;
            let last_seen;
            if (data.created_at) {
                created_at = data.created_at.toDate();
            }
            else if (data.timestamp) {
                created_at = new Date(data.timestamp);
            }
            if (data.last_seen) {
                last_seen = data.last_seen.toDate();
            }
            const { timestamp, ...rest } = data;
            return { ...rest, id: snapshot.id, created_at, last_seen };
        },
    };
}
export function _createInvitedConverter(Timestamp) {
    return {
        toFirestore(modelObject) {
            const data = { ...modelObject };
            data.timestamp = Timestamp.fromDate(data.timestamp);
            return data;
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            const timestamp = data.timestamp.toDate();
            return {
                ...data,
                timestamp,
                id: snapshot.id,
            };
        },
    };
}
/** Additional improvements:
 * 1. accepts a Mimbox class as param so we can create a frontend and a backend version if we want to hook in specific functions */
export function _createMimboxConverter() {
    return {
        toFirestore(modelObject) {
            return modelObject.dump();
        },
        fromFirestore(snapshot) {
            const data = snapshot.data();
            const installDate = data.install?.date;
            if (dateIsTimestamp(installDate)) {
                data.install.date = installDate.toDate();
            }
            return new Mimbox({ ...data, id: snapshot.id }, snapshot.ref);
        },
    };
}
//# sourceMappingURL=implementations.js.map